<template>
  <div class="checkbox-group">
    <div v-for="option in options" :key="option.key" class="form-check form-check-custom form-check-solid mb-2">
      <input 
        class="form-check-input" 
        type="checkbox"
        :id="option.key"
        :value="option.key"
        v-model="modelValue"
      />
      <label :for="option.key" class="form-check-label fs-6 fw-bolder text-black">
        {{ option.value }}
      </label>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineModel } from 'vue';

const modelValue = defineModel({ type: Array, required: true });

defineProps({
  options: { type: Array, required: true }, 
  isRequired: {type: Boolean, required: false}
});
</script>

<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
}
.form-check.form-check-solid .form-check-input:checked {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary); 
}

.form-check.form-check-solid .form-check-input {
    border: 0;
    background-color: #eff2f5;
}
</style>
